"use client";

import { useState } from "react";
import { cn } from "@/lib/utils";
import { IMAGE_WIDTHS, unsplash, unsplashSrcSet } from "@/lib/images";

type Props = {
  imageId: string;
  alt: string;
  width: number;
  height: number;
  sizes: string;
  widths?: readonly number[];
  className?: string;
  imgClassName?: string;
  priority?: boolean;
  fill?: boolean;
};

export function AppImage({
  imageId,
  alt,
  width,
  height,
  sizes,
  widths = IMAGE_WIDTHS.wide,
  className,
  imgClassName,
  priority = false,
  fill = false,
}: Props) {
  const [failed, setFailed] = useState(false);

  return (
    <div
      className={cn(
        fill ? "absolute inset-0" : "relative",
        "overflow-hidden bg-line",
        failed && "floor-placeholder",
        className,
      )}
      style={fill ? undefined : { aspectRatio: `${width} / ${height}` }}
    >
      {failed ? (
        <span className="sr-only">{alt}</span>
      ) : (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={unsplash(imageId, widths[widths.length - 1])}
          srcSet={unsplashSrcSet(imageId, widths)}
          sizes={sizes}
          alt={alt}
          width={width}
          height={height}
          loading={priority ? "eager" : "lazy"}
          decoding={priority ? "sync" : "async"}
          fetchPriority={priority ? "high" : "auto"}
          onError={() => setFailed(true)}
          className={cn(
            "absolute inset-0 h-full w-full object-cover",
            imgClassName,
          )}
        />
      )}
    </div>
  );
}
